import { render, staticRenderFns } from "./OnSuccess.vue?vue&type=template&id=2ba5927e&"
import script from "./OnSuccess.vue?vue&type=script&lang=js&"
export * from "./OnSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports